import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//estilos 
import './assets/css/default.css';
import "bootstrap/dist/css/bootstrap.css";
import 'react-datetime/css/react-datetime.css';

ReactDOM.render(<App />, document.getElementById('root'));